var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcUnpicked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 26,
    viewBox: "0 0 52 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 52,
    height: 24,
    rx: 8,
    fill: "#F5F5F5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 13.4444L15.125 17L22 9",
    stroke: "#909090",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1426 7.86914H29.4844V8.93555H30.6465V12.6064C30.1201 12.6064 29.6211 12.6133 29.1562 12.6133L29.3066 13.6934C31.4395 13.7002 34.2832 13.6523 36.7852 13.2695L36.7031 12.3125C36.1426 12.374 35.5615 12.4219 34.9668 12.4629V8.93555H36.1426V7.86914ZM30.8105 15.9766H37.8105V19.1621H39.1094V14.9238H30.8105V15.9766ZM31.8906 12.5859V8.93555H33.7227V12.5244C33.1074 12.5518 32.4922 12.5723 31.8906 12.5859ZM37.8105 14.3633H39.1094V6.91211H37.8105V14.3633Z",
    fill: "#909090"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUnpicked);
export default __webpack_public_path__ + "static/media/ic_unpicked.f186639eb1d0482f03a9ac1a5e0218f9.svg";
export { ForwardRef as ReactComponent };